import { Entity } from "@jobilla/entity";

export class HubspotDeal extends Entity {
  public id!: number;
  public url!: string;
}
